// src/integrations/SmsIntegration.ts
import type { IntegrationInterface } from '@/interfaces/IntegrationInterface'
import { apiPostPublic } from '../util/api'

export class SmsIntegration implements IntegrationInterface {
    // Send verification code - new method
    async sendVerificationCode(mobileNumber: string): Promise<any> {
        const response = await apiPostPublic<{ status: any; require_verification: boolean }>(
            'auth/sms_verification',
            { mobile_number: mobileNumber }
        )

        return response.data
    }

    // Login with verification code
    async login(credentials: any): Promise<any> {
        // Update parameter names to match backend expectations
        const { mobile_number, verification_code } = credentials.user || {}

        // Structure the user object to match backend expectations
        const user = { mobile_number, verification_code }

        // Make the API call
        const response = await apiPostPublic<{ data: any }>('auth/login', {
            user,
            integration_id: 'sms'
        })

        return {
            headers: {
                Authorization:
                    response.headers?.['Authorization'] || response.headers?.['authorization']
            },
            data: response.data
        }
    }
}
